/* eslint  max-len: 0 */
import React, { useCallback } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  addToBetSlip,
  deleteFromBetSlip,
} from 'redux/configs/betConfigsSlice';
import { getEventMarkets } from 'redux/Event-markets/eventMarketSlice';
import formatDateTime from 'components/helpers/formatDateTime';
import { setDetails } from 'redux/nav-header/navHeader';
import themeAssets from 'assets/theme-assets';
import baseUrls from '../../../config';

const makeSelectMatchBetIds = (matchId) => (store) => store.betSlip.bets
  .filter((b) => b.matchId === matchId)
  .map((b) => b.uniqueId);

const SportItem = ({ event, redirect, isMobile }) => {
  const assets = themeAssets[process.env.REACT_APP_THEME_NAME];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const imgUrl = baseUrls.BASE_URL_IMG;
  const { cleanedMarkets } = useSelector((store) => store.topMatchesMkts);
  const { tournament } = useSelector((store) => store.navigationHeader);
  const {
    outcome, info, id, time, number, count,
  } = event;

  const matchBetUniqueIds = useSelector(makeSelectMatchBetIds(id), shallowEqual);
  const activeBetIds = new Set(matchBetUniqueIds);

  const handleButtonClick = useCallback((match, market, uniqueId) => {
    if (activeBetIds.has(uniqueId)) {
      dispatch(deleteFromBetSlip(uniqueId));
    } else {
      dispatch(addToBetSlip({
        match,
        odds: market.odds,
        team: market.name,
        market: market.market.name,
        matchId: match.id,
        id: market.id,
        uniqueId: market.uniqueId,
        inBetSlip: market.inBetSlip,
        matchNumber: match.number,
        pick: `${match.number}*${market.market.id}*${market.outcome_id}`,
      }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeBetIds, dispatch]);

  const handleMoreButtonClick = useCallback(() => {
    if (tournament === null) {
      navigate('/dashboard');
    } else {
      const name = `${info.teamhome.name} VS ${info.teamaway.name}`;
      dispatch(setDetails({ name, redirect }));
      dispatch(getEventMarkets(id));
      localStorage.setItem('eventDetails', JSON.stringify(event));
      localStorage.setItem('details-back', redirect);
    }
  }, [tournament, navigate, info, redirect, dispatch, id, event]);

  const formattedDate = formatDateTime(time);

  if (!outcome || outcome.length === 0) return null;

  return (
    <li key={event.id}>
      <div className="match-card">
        {!isMobile && (
        <div className="sport">
          <img src={`${imgUrl}${info.sport.icon}`} alt="" />
        </div>
        )}
        <div className="middle-info">
          <div className="left">
            {isMobile && (
            <div className="sport">
              <img src={`${imgUrl}${info.sport.icon}`} alt="" />
            </div>
            )}
            <div className="team-info">
              {!isMobile && (<span className="number">{number}</span>)}
              {isMobile && (<span className="hour">{formattedDate}</span>)}
              <span>{info.teamhome.name}</span>
              <span>{info.teamaway.name}</span>
            </div>
            {!isMobile && (<span className="hour">{formattedDate}</span>)}
            {isMobile && (
            <div className="end-info">
              <span className="number">{number}</span>
              <span>
                +
                {count}
              </span>
              <span>{`${info.category.name} - ${info.tournament.name}`}</span>
            </div>
            )}
            {isMobile && (
            <div className="more-info">
              <NavLink
                className="btn btn-more"
                to="/dashboard/match-details"
                onClick={handleMoreButtonClick}
              >
                <img src={assets.arrowRight} alt="" />
              </NavLink>
            </div>
            )}
          </div>
          <div className="right">
            <div className="out-comes">
              {outcome.map((x) => {
                const isActive = activeBetIds.has(x.uniqueId);
                const display = cleanedMarkets[`${x?.market?.id}-${x?.id}`] ?? x.display;
                const isLong = display.length > 6;
                return (
                  <button
                    key={x.id}
                    type="button"
                    className={`btn btn-outcome${isActive ? ' marked-btn' : ''}${isLong ? ' ellipse-expand' : ''}`}
                    onClick={() => {
                      handleButtonClick(event, x, x.uniqueId);
                    }}
                  >
                    <span>
                      {display}
                    </span>
                    <span className="odd">{x.odds}</span>
                  </button>
                );
              })}
            </div>
            {!isMobile && (
            <div className="tournament-info">
              <span>
                +
                {count}
              </span>
              <span>-</span>
              <span>{`${info.category.name} - ${info.tournament.name}`}</span>
            </div>
            )}
          </div>
        </div>
        {!isMobile && (
        <div className="more-info">
          <NavLink
            className="btn btn-more"
            to="/dashboard/match-details"
            onClick={handleMoreButtonClick}
          >
            <img src={assets.arrowRight} alt="" />
          </NavLink>
        </div>
        )}
      </div>
    </li>
  );
};
SportItem.propTypes = {
  event: PropTypes.oneOfType([PropTypes.object]).isRequired,
  redirect: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default SportItem;
